import XEUtils from "xe-utils";

/**
 * formatFormLoad 格式化表单加载
 * @param entity 详情数据
 * @param baseCode 需要格式化的通用代码字段集
 * @param isKey 需要格式化的开关字段集
 * @return {Object|{}}
 */
function formatFormLoad(entity = {}, baseCode = [], isKey = []) {
	let data = {};
	if (entity.code === 200) {
		data = entity.data;
	} else {
		return entity;
	}
	console.log(data)
	if (typeof data === 'object' && data instanceof Object) {
		if (!baseCode || !Array.isArray(baseCode) || !baseCode.length) {
			baseCode = [];
		}
		if (!isKey || !Array.isArray(isKey) || !isKey.length) {
			isKey = [];
		}

		for (let item in data) {
			if (Object.prototype.hasOwnProperty.call(data, item)) {
				//复选通用代码 解析为数组
				if (baseCode.includes(item)) {
					data[item] = data[item] ? data[item].split(',').map((i) => {
						if (typeof i === "number"){
                            return parseInt(i)
						}else if(typeof i === "string"){
							return i;
						}
                        return i;
					}) : [];
				}
				//开关 1,0 转为布尔
				if (isKey.includes(item)) {
					data[item] = !!data[item];
				}
			}
		}
		entity.data = data;
		return entity;
	} else {
		return entity;
	}
}

/**
 * 格式化复选回调值，转为number类型的数组
 * @param val
 */
function formatMultiSelect(val) {
	if (val) {
		let arr = val.split(',');
		return arr.map(val => {
			return parseInt(val);
		});
	} else {
		return [];
	}
}

/**
 * 将复选框内容格式化为,分隔字符串
 * @param val
 */
function formatMultiSelectToString(val) {
	if (val && val.length && Array.isArray(val)) {
		return val.join(',');
	} else {
		return '';
	}
}


/**
 * 处理出下拉带的名称/其他值
 * @param options 下拉数组
 * @param val val值
 * @param key 想获取的字段名
 */
function formatSelectValToName(options, val, key = 'label') {
	/*if (typeof val === 'number' && val) {
		return options.filter(v => {
			return v.value === val
		})[0][key] || '';
	} else if (typeof val === 'string' && val) {
		let arr = val.split(',');
		let nameArr = [];
		arr.forEach(value => {
			let name = options.filter(v => {
				return v.value === value
			})[0][key] || '';
			if (name) {
				nameArr.push('name');
			}
		})
		return nameArr.join(',');
	}*/

    if (typeof val === 'number' && val) {
        let arr = options.filter(v => {
            return v.value === val
        });
        return arr.length ? arr[0][key] : ''
        // return options.filter(v => {
        // 	return v.value === val
        // })[0][key] || '';
    } else if (typeof val === 'string' && val) {
        let arr = val.split(',');
        let nameArr = [];
        arr.forEach(value => {
            let arr = options.filter(v => {
                return v.value === value
            });
            let name = arr.length ? arr[0][key] : '';
            if (name) {
                nameArr.push(name);
            }
        })
        return nameArr.join(',');
    }
}


/**
 * 格式化金额，并添加$前缀
 * @param cellValue
 * @param prefix
 * @returns {string|string}
 */
function formatMoney({cellValue}, prefix = "$") {
	return cellValue || cellValue === 0? `${prefix}${XEUtils.commafy(XEUtils.toNumber(cellValue), {digits: 2})}` : ''
}

/**
 * 格式化为长日期格式
 * @param value
 * @returns {*}
 */
function formatLongDate(value) {
	return XEUtils.toDateString(value, 'yyyy-MM-dd HH:ss:mm')
}

/**
 * 格式化为短日期格式
 * @param value
 * @returns {*}
 */
function formatShortDate(value) {
	return XEUtils.toDateString(value, 'yyyy-MM-dd')
}


const RE_EMAIL = /^\s*[\w.-]+@([\w-]+\.)+(\w+)\s*$/

/**
 * 格式化链接，如果参数是邮箱地址，则添加mailto协议
 * @param cellValue
 * @returns {string}
 */
function formatLink({cellValue}) {
	let protocol = RE_EMAIL.test(cellValue) ? "mailto:" : "";
	return `<a href="${protocol}${cellValue}" target="_blank">${cellValue}</a>`
}

const SEX_MAP = {
	"1": "男",
	"M": "男",
	"MALE": "男",
	"0": "女",
	"F": "女",
	"FEMALE": "女",
	"男": "男",
	"女": "女"
};

/**
 * 格式化性别
 * @param cellValue
 * @returns {*}
 */
function formatSex({cellValue}) {
	let s = SEX_MAP[String(cellValue).toUpperCase()];
	return s || "-";
}

/**
 * 如果值为true，则显示"是"
 * @param cellValue
 * @returns {string}
 */
function formatYes({cellValue}) {
	return formatYesNo({cellValue}) === "是" ? "是" : "";
}

const YES_NO_MAP = {
	"1": "是",
	"YES": "是",
	"Y": "是",
	"TRUE": "是",
	"0": "否",
	"NO": "否",
	"N": "否",
	"FALSE": "否"
};

function formatYesNo({cellValue}) {
	let s = YES_NO_MAP[String(cellValue).toUpperCase()];
	return s || "-";
}

function formatLong({cellValue}) {
	let s = parseInt(cellValue);
	return s || 0;
}

let formatter = {
	formatLong,
	formatMoney,
	formatLongDate,
	formatShortDate,
	formatSex,
	formatLink,
	formatYes,
	formatYesNo,
	formatMultiSelect,
	formatMultiSelectToString,
	formatSelectValToName,
	formatFormLoad
}

export {
	formatter
}